import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children, headerVariant = "light", withFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header variant={headerVariant} />
      <main className="flex-1">{children}</main>
      {withFooter && <Footer />}
    </div>
  );
}
